import { createFileRoute } from "@tanstack/react-router";
import { AgeGroupPage } from "@/components/site/age-group";
import { fixturesQuery, newsByCategoryQuery, squadQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/u20")({
  head: () => ({
    meta: [
      { title: "Argentina U20 | Argentinian.Soccer" },
      { name: "description", content: "Argentina U20 news, fixtures, squad and statistics." },
      { property: "og:title", content: "Argentina U20 | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/u20" },
    ],
    links: [{ rel: "canonical", href: "/national-team/u20" }],
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(newsByCategoryQuery("national_team", 4)),
      context.queryClient.ensureQueryData(fixturesQuery("u20", 6)),
      context.queryClient.ensureQueryData(squadQuery("u20")),
    ]),
  component: () => <AgeGroupPage scope="u20" title="Argentina U20" eyebrow="U20" />,
});
